/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { ExportToolResponse } from '../types/ExportTool';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type ExportToolsRetrieveRequest = {} | null | undefined;
export type ExportToolsRetrieveResponse = ExportToolResponse;

export type ExportToolsRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this export tool.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * GET /dmx-server/export_tools/{id}/
 *
 * ```yaml
 * operationId: export_tools_retrieve
 * tags:
 *   - export_tools
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ExportTool'
 *     description: ''
 * ```
 */
export const exportToolsRetrieveOperation = ({ id, ...rest }: ExportToolsRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/export_tools/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/export_tools/{id}/' };
  };

/**
 * GET /dmx-server/export_tools/{id}/
 *
 * ```yaml
 * operationId: export_tools_retrieve
 * tags:
 *   - export_tools
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ExportTool'
 *     description: ''
 * ```
 */
export const exportToolsRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: ExportToolsRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<ExportToolResponse>> => {
  const operation = exportToolsRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/export_tools/{id}/
 */
export const useExportToolsRetrieveResource = (
  query: ExportToolsRetrieveQuery | null,
  useCached?: boolean,
): UseResource<ExportToolsRetrieveResponse> => {
  return useResource<ExportToolsRetrieveResponse>({
    path: query === null ? null : exportToolsRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
